export default class MathUtils {
  /**
   * 檢查 frame gap 錯誤
   * @returns 錯誤回 true
   */
  static checkFrameGapIsError(countFrameNumber, startGap, endGap) {
    // 1. 等於start
    // 2. 不允許start到end中間的數值
    // 3. 或大於等於end
    if(parseFloat(startGap) == parseFloat(countFrameNumber) ){
        // 沒錯
        return false;
    }
    if(parseFloat(startGap) < parseFloat(countFrameNumber) && parseFloat(countFrameNumber) < parseFloat(endGap)){
         // 錯
        return true;
    }
    if( parseFloat(countFrameNumber) > parseFloat(endGap)){
         // 沒錯
         return false;  
    } 

    // 最後回應是錯的
    return true;
  }

  static round_decimal(value, decimal) {
    const decimalR = Math.pow(10, decimal);
    return Math.round(value * decimalR) / decimalR;
    // return decimalR;
  }

  static dec2hexBy2(i) {
    let result = "00";
    if (i >= 0 && i <= 15) {
      result = "0" + i.toString(16);
    } else if (i >= 16 && i <= 255) {
      result = "" + i.toString(16);
    }
    return result;
  }

  static dec2hexBy4(i) {
    let result = "0000";
    if (i >= 0 && i <= 15) {
      result = "000" + i.toString(16);
    } else if (i >= 16 && i <= 255) {
      result = "00" + i.toString(16);
    } else if (i >= 256 && i <= 4095) {
      result = "0" + i.toString(16);
    } else if (i >= 4096 && i <= 65535) {
      result = i.toString(16);
    }
    return result;
  }

  static hexToInt(x, base) {
    var parsed = parseInt(x, base);
    if (isNaN(parsed)) {
      return 0;
    }
    return parsed;
  }

  //除法函数，用来得到精确的除法结果
  //说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
  //调用：accDiv(arg1,arg2)
  //返回值：arg1除以arg2的精确结果
  static accDiv(arg1, arg2) {
    var t1 = 0,
      t2 = 0,
      r1,
      r2;
    try {
      t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
      t2 = arg2.toString().split(".")[1].length;
    } catch (e) {}
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }
  //乘法函数，用来得到精确的乘法结果
  //说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
  //调用：accMul(arg1,arg2)
  //返回值：arg1乘以arg2的精确结果
  static accMul(arg1, arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  }
  //加法函数，用来得到精确的加法结果
  //说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
  //调用：accAdd(arg1,arg2)
  //返回值：arg1加上arg2的精确结果
  static accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
  }
  //减法函数
  static accSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    //last modify by deeka
    //动态控制精度长度
    n = r1 >= r2 ? r1 : r2;
    return ((arg2 * m - arg1 * m) / m).toFixed(n);
  }

  // //给Number类型增加一个add方法，调用起来更加方便。
  // Number.prototype.add = function (arg) {
  //     return accAdd(arg, this);
  // };
  // //给Number类增加一个sub方法，调用起来更加方便
  // Number.prototype.sub = function (arg) {
  //     return accSub(arg, this);
  // };
  // //给Number类型增加一个mul方法
  // Number.prototype.mul = function (arg) {
  //     return accMul(arg, this);
  // };
  // //给Number类型扩展一个div方法
  // Number.prototype.div = function (arg) {
  //     return accDiv(this, arg);
  // };
}



// WEBPACK FOOTER //
// ./src/helper/MathUtils.js